function formatPrice(price, currency) {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + '<small> ' + currency + '</small>'
}

var that;

export default class DiscountComponent {

    /**
     *
     * @param selector
     */
    constructor(selector) {
        this.selector = selector;
        this.isDiscountValid = true;
        this.isDiscountEntered = false;
        that = this;
        this.initEvents();
    }

    initEvents() {
        $('#use-discount-code').on('click', this.checkDiscountCode);

        const code = that.selector.val();
        if(code.length > 0){
            this.checkDiscountCode();
        }

    }

    checkDiscountCode() {
        const code = that.selector.val();
        if (code.length > 0 || (that.isDiscountEntered && that.isDiscountValid)) {
            that.isDiscountEntered = true;
            $.ajax({
                type: 'POST',
                url: '/main/cart/check-discount-code',
                data: {code: code},
                dataType: 'json',
                success: function (data) {
                    that.isDiscountValid = data.valid;
                    Object.keys(data.product_prices).forEach(key => {
                        const cartItem = $(`.cart-item[data-product-id='${key}']`);
                        const newPrice = cartItem.find('.cart-item__price > .amount:not(.price-before-discount)');
                        const oldPrice = cartItem.find('.cart-item__price > .amount.price-before-discount');

                        if (!data.product_discounts[key].codeDiscount && data.product_discounts[key].id) {
                            that.isDiscountEntered = false;
                            that.isDiscountValid = false;
                        }

                        if ((data.product_discounts[key].codeDiscount || data.product_discounts[key].id) && data.product_discounts[key].multiplier !== 1) {
                            cartItem.addClass('cart-item__hasDiscount');
                            newPrice.addClass('red-amount');
                            oldPrice.show();
                            newPrice.html(formatPrice(data.product_prices[key].price, data.product_prices[key].currency));
                        } else {
                            cartItem.removeClass('cart-item__hasDiscount');
                            newPrice.removeClass('red-amount');
                            newPrice.html(oldPrice.html()).removeClass('price-before-discount').show();
                            oldPrice.hide();
                        }
                    });

                    $('.cart-item.summary-cart-item > .cart-item__price > .amount').html(formatPrice(data.total.price, data.total.currency));
                }, error: function () {
                    that.isDiscountValid = false;
                }
            });
        } else {
            that.isDiscountValid = true;
            that.isDiscountEntered = false;
        }
    }

    getIsDiscountValid() {
        return this.isDiscountValid();
    }

    getIsDiscountEntered() {
        return this.isDiscountEntered();
    }
}
